const integrationServicesData = [
  {
    title: "Data Integration Solutions",
    description:
      "We connect systems and synchronize data across applications, creating streamlined processes and robust DBMS to ensure data integrity during transfers.",
    bullets: [
      "Data Transformation",
      "Real-Time Sync",
      "Data Consolidation",
      "Efficient Data Alignment",
    ],
    minHeight: 420,
  },
  {
    title: "Enterprise Application Integrations",
    description:
      "We deliver seamless EAI services, connecting CMS, ERP, CRM, accounting, and digital marketing platforms for efficient business operations.",
    bullets: [
      "Process Automation",
      "Cross-Platform Synchronization",
      "Workflow Integration",
      "Unified Data View",
    ],
    minHeight: 420,
  },
  {
    title: "API Integration Solutions",
    description:
      "Our team expertly integrates custom and third-party APIs, enhancing app functionality and ensuring smooth data flow with tools like Jitterbit and Azure.",
    bullets: [
      "Secure API Gateways",
      "Data Synchronization",
      "Web Service Integration",
      "Performance Optimization",
    ],
    minHeight: 420,
  },
  {
    title: "Service-Oriented Architecture",
    description:
      "We design SOA frameworks that enable efficient service deployment, ensuring fast data access, integration, and system independence.",
    bullets: [
      "System integration",
      "Service Deployment",
      "System Reusability",
      "Rapid Data Retrieval",
    ],
    minHeight: 420,
  },
  {
    title: "AI Integration Solutions",
    description:
      "We embed AI into software systems to automate tasks, improve accuracy, and boost productivity by reducing errors and streamlining data exchanges.",
    bullets: [
      "Predictive Analytics",
      "Natural Language Processing",
      "Machine Learning Models",
      "Automated Insights",
    ],
    minHeight: 420,
  },
  {
    title: "Integration Support Services",
    description:
      "We provide ongoing support, maintenance, and security monitoring to keep your integrated systems running smoothly and securely.",
    bullets: [
      "Performance Optimization",
      "Customer Assistance",
      "24/7 Monitoring",
      "Functionality Assurance",
    ],
    minHeight: 420,
  },
];

// From sections/custom-software-integration/IntegrationSolutions.jsx
export const integrationTiles = [
  { icon: "fa-solid fa-code", label: "Application Development" },
  { icon: "fa-solid fa-right-left", label: "Migrations and Upgrades" },
  { icon: "fa-solid fa-diagram-project", label: "API Development" },
  { icon: "fa-regular fa-circle", label: "Product Lifecycle\nManagement" },
  { icon: "fa-solid fa-screwdriver-wrench", label: "Application\nMaintenance" },
  { icon: "fa-regular fa-circle-check", label: "Quality\nAssurance" },
  { icon: "fa-solid fa-database", label: "Backup &\nRecovery" },
  { icon: "fa-solid fa-handshake-angle", label: "SLA Support" },
  { icon: "fa-solid fa-rocket", label: "Implementation &\nDeployment" },
  { icon: "fa-solid fa-server", label: "Infrastructure\nSupport" },
  { icon: "fa-solid fa-shield-halved", label: "Software\nSecurity" },
];

// From sections/custom-software-integration/WebsocketUpgrade.jsx
export const websocketUpgradeFeatures = [
  {
    icon: "fa-solid fa-circle-nodes",
    title: "Event Pattern Publishing",
    desc: "Our team designs and implements messaging systems that facilitate easy and seamless server interactions, ensuring efficient event publishing and response handling.",
  },
  {
    icon: "fa-solid fa-arrows-spin",
    title: "Bidirectional Data Exchange",
    desc: "We enable simultaneous data exchange in both directions through a single connection, minimizing network congestion and latency.",
  },
  {
    icon: "fa-solid fa-right-left",
    title: "Upstream and Downstream Communication",
    desc: "We develop integration services that support two-way communication, including streaming through proxies and firewalls.",
  },
  {
    icon: "fa-regular fa-square-check",
    title: "Backward Compatibility with HTTP",
    desc: "We ensure that our WebSocket solutions are backward compatible with HTTP connections, optimizing the content flow between servers and clients.",
  },
];

export default integrationServicesData;
